import PointAndClickScene from "@/models/PointAndClickScene";
import {
    AndreasInRoom,
    ArtFlamenco,
    BackgroundRoomCarlos,
    BedAssistance,
    Blanket, CatRobot,
    Chair,
    ClockDigitalDate2,
    MiningHelmet,
    MiningLamp,
    PhotoCat,
    PhotoWedding,
    Plant4, Wheelchair
} from "@/assets/data/objects/ZORO-003-objects";
import PointAndClickCharacter from "@/models/PointAndClickCharacter";
import { Blink } from "@/assets/data/animations/animations";
import PointAndClickItem from "@/models/PointAndClickItem";

export const Zoro003FollowupRoomTalkRecipientCarlosScene = new PointAndClickScene({
    id: 'zoro-002-followup-hospital_room_talk_recipient',
    startLocation: 'room-carlos',
    showPhoneButton: false,
    locations: {
        'room-carlos': {
            items: [
                BackgroundRoomCarlos,

                ArtFlamenco,
                MiningLamp,
                PhotoCat,
                Plant4,
                ClockDigitalDate2,

                PhotoWedding,
                MiningHelmet,
                BedAssistance,
                Blanket,

                Chair,

                new PointAndClickItem({
                    ...AndreasInRoom,
                    pos: { left: 202, top: 285 },
                    interactable: true,
                    itemType: 'action',
                    hoverType: 'talk',
                    action: 'talk_with_recipient',
                    name: 'Praat met Andreas en Carlos'
                }),
                new PointAndClickItem({
                    ...Wheelchair,
                    scale: { x: -1, y: 1 }
                }),
                new PointAndClickItem({
                    ...CatRobot,
                    pos: { left: 588, top: 716 },
                }),
            ],
            characters: [
                new PointAndClickCharacter({
                    id: 'carlos',
                    layer: 5,
                    imgElements: [
                        {
                            id: 'carlos_bg',
                            img: require('@/assets/images/characters/zorgontvanger_c3/zorgontvanger_c3_dialog_body.png'),
                            pos: { left: 600, top: 160 }
                        },
                        {
                            id: 'eyes',
                            pos: { left: 876, top: 452 },
                            layer: 2,
                            img: require('@/assets/images/characters/zorgontvanger_c3/zorgontvanger_c3_dialog_eo.png'),
                            frames: [
                                {
                                    id: "open",
                                    img: require('@/assets/images/characters/zorgontvanger_c3/zorgontvanger_c3_dialog_eo.png')
                                },
                                {
                                    id: "closed",
                                    img: require('@/assets/images/characters/zorgontvanger_c3/zorgontvanger_c3_dialog_ec.png')
                                }
                            ],
                            timing: Blink.timing,
                        },
                        {
                            id: 'mouth',
                            pos: { left: 885, top: 533 },
                            layer: 2,
                            img: require('@/assets/images/characters/zorgontvanger_c3/zorgontvanger_c3_dialog_mc.png'),
                            frames: [
                                {
                                    id: "closed",
                                    img: require('@/assets/images/characters/zorgontvanger_c3/zorgontvanger_c3_dialog_mc.png')
                                },
                                {
                                    id: "open",
                                    img: require('@/assets/images/characters/zorgontvanger_c3/zorgontvanger_c3_dialog_mo.png')
                                }
                            ],
                            timing: [
                                {
                                    duration: 100,
                                    frameId: "open"
                                },
                                {
                                    duration: 100,
                                    frameId: "closed"
                                },
                            ],
                        }
                    ],
                })
            ]
        }
    }
});